import { formatMoney } from "@/utils/StringUtils";
import { styled } from "@mui/material";
import { useCheckoutUI } from "../../CheckoutUIProvider";

const TotalContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  color: theme.palette.primary.main,
}));

const TotalRow = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontSize: "14px",
  color: theme.palette.primary.main,
}));

const TotalRowBold = styled(TotalRow)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 600,
  marginTop: "4px",
  paddingTop: "12px",
  color: theme.palette.primary.main,
  borderTop: `1px solid ${theme.palette.primary.main}`,
}));

export const CartTotal = () => {
  const [state] = useCheckoutUI();

  const { checkoutIntent } = state.context;

  if (!checkoutIntent?.estimatedOrderSummary) {
    return null;
  }

  const {
    estimatedOrderSummary: {
      subtotal,
      shippingFees: estimatedShipping,
      tax: estimatedTax,
      total: amountToCharge,
    },
    items,
  } = checkoutIntent;

  return (
    <TotalContainer>
      <TotalRow>
        <span>
          Subtotal ({items?.length} item{items?.length === 1 ? "" : "s"})
        </span>
        <span>{formatMoney(subtotal)}</span>
      </TotalRow>
      <TotalRow>
        <span>Shipping Fee (Est. 1-2 days)</span>
        <span>{formatMoney(estimatedShipping)}</span>
      </TotalRow>
      <TotalRow>
        <span>Estimated tax</span>
        <span>{formatMoney(estimatedTax)}</span>
      </TotalRow>
      <TotalRow>
        <span>Service fee</span>
        <span>{formatMoney(0)}</span>
      </TotalRow>
      <TotalRowBold>
        <span>Total</span>
        <span>{formatMoney(amountToCharge)}</span>
      </TotalRowBold>
    </TotalContainer>
  );
};
